import Dexie from "dexie";

export interface Habit {
  id: string;
  name: string;
  arcId: string;
  timeOfDay: { hour: string; minute: string; sec?: string };
  isEditing?: boolean;
  completed: { [date: string]: boolean }; // Object where keys are dates and values are completion status
}

export interface Arc {
  id?: number;
  name: string;
  arcId: string;
  timePeriod: string;
  startDate: Date;
  habits: Habit[];
  color: string;
}

class ArcsDatabase extends Dexie {
  arcs: Dexie.Table<Arc, number>;

  constructor() {
    super("ArcsDatabase");
    this.version(2).stores({
      arcs: "++id,arcId,name,timePeriod,startDate,color",
    });
    this.arcs = this.table("arcs");
  }

  async addArc(
    name: string,
    arcId: string,
    timePeriod: string,
    startDate: Date,
    habits: Habit[],
    color: string
  ): Promise<number> {
    console.log("start:: ", startDate);
    return this.arcs.add({ arcId, name, timePeriod, startDate, habits, color });
  }

  async getAllArcs(): Promise<Arc[]> {
    return this.arcs.toArray();
  }

  async getColorByArcId(arcId: string): Promise<string> {
    const allArcs = await this.getAllArcs();
    const arc: any = allArcs.filter((arc) => arc.arcId === arcId);
    console.log("color ", arc[0].color);
    return arc[0].color;
  }

  async markHabitCompleted(
    habitId: string,
    arcId: string,
    date: string
  ): Promise<void> {
    const arc = await this.arcs.where("arcId").equals(arcId).first();

    if (arc) {
      const index = arc.habits.findIndex((habit) => habit.id === habitId);
      if (index !== -1) {
        // Update the completion status for the specified date
        arc.habits[index].completed[date] = true;
        await this.arcs.update(arc.id!, { habits: arc.habits });
        return;
      } else {
        throw new Error(
          `Habit with ID ${habitId} not found in arc with ID ${arcId}.`
        );
      }
    } else {
      throw new Error(`Arc with ID ${arcId} not found.`);
    }
  }

  async getHabitsByDate(date: Date): Promise<Habit[]> {
    const dateString = date.toLocaleDateString();
    const allArcs = await this.getAllArcs();
    const habitsByDate: Habit[] = [];

    // Iterate over all arcs
    for (const arc of allArcs) {
      // Check if the date falls within the time period of the arc
      const startDate = new Date(arc.startDate);
      const endDate = new Date(
        startDate.getTime() + parseInt(arc.timePeriod) * 24 * 60 * 60 * 1000
      );

      if (date >= startDate && date <= endDate) {
        // If the date is within the time period, add habits for that date
        for (const habit of arc.habits) {
          if (habit.completed[dateString]) {
            habitsByDate.push(habit);
          }
        }
      }
    }

    return habitsByDate;
  }

  async getArcById(arcId: string): Promise<string> {
    const allArcs = await this.getAllArcs();
    const arc: any = allArcs.filter((arc) => arc.arcId === arcId);
    console.log("arcccc ", arc[0].name);
    return arc[0].name;
  }

 
  

  async getHabitsByDateAndArcId(date: Date, arcId: string): Promise<Habit[]> {
    const dateString = date.toLocaleDateString();
    const allArcs = await this.getAllArcs();
    const habitsByDate: Habit[] = [];

    // Iterate over all arcs
    for (const arc of allArcs) {
      if (arc.arcId !== arcId) continue;
      // Check if the date falls within the time period of the arc
      const startDate = new Date(arc.startDate);
      const endDate = new Date(
        startDate.getTime() + parseInt(arc.timePeriod) * 24 * 60 * 60 * 1000
      );

      if (date >= startDate && date <= endDate) {
        // If the date is within the time period, add habits for that date
        for (const habit of arc.habits) {
          if (habit.completed[dateString]) {
            habitsByDate.push(habit);
          }
        }
      }
    }

    return habitsByDate;
  }
  async getHabitsForToday(): Promise<Habit[]> {
    const today = new Date(); // Get today's date
    const allArcs = await db.getAllArcs(); // Get all arcs from the database
    const habitsForToday: Habit[] = [];
  
    // Iterate over all arcs
    for (const arc of allArcs) {
      const startDate = new Date(arc.startDate); // Convert arc's startDate to Date object
  
      const endDate = new Date();
      endDate.setDate(startDate.getDate() + Number(arc.timePeriod) - 1);
  
      console.log("timePeriodInMs ", startDate, endDate);
      // Check if today's date falls within the time period of the arc
      if (today >= startDate && today <= endDate) {
        // If today's date is within the time period, add all habits of this arc to habitsForToday
        for (const habit of arc.habits) {
          // Check if the habit's completion status for today is true
          if (!habit.completed[today.toLocaleDateString()]) {
            console.log("habit", habit);
            habitsForToday.push(habit);
          }
        }
      }
    }
  
    console.log("habitsForToday", habitsForToday);
    return habitsForToday;
  }
}


export const db = new ArcsDatabase();
